import { computed, ref } from "vue"
import type { RouteLocationNormalizedLoaded } from "vue-router"

import { getPageQuery } from "@/composables/use-page"
import { getPage } from "@/composables/get-page"
import { groupPageQuery, type KirbyGroupPageData } from "@/queries/group"
import { KirbyStudentPageData, studentPageQuery } from "@/queries/student"
import type { KirbyBlock } from "@/queries/blocks"
import { resolveStudentName } from "@/utils/student"
import { PathUtils } from "@/utils/path.utils"

const removeEmptyBlocks = (blocks: KirbyBlock[]) =>
  blocks.filter(block => {
    if (block.type === "image" && !block.content.image?.length) return false
    if (block.type === "video" && !block.content.url) return false
    if (block.type === "sketchfab" && !block.content.url) return false
    return true
  })

export async function useStudentPage(route: RouteLocationNormalizedLoaded) {
  const _query = getPageQuery(PathUtils.strip(route.path), studentPageQuery)
  const page = await getPage<KirbyStudentPageData>(_query)

  let groupData: KirbyGroupPageData | undefined
  if (page.template === "studentgroup") {
    const groupQuery = getPageQuery(PathUtils.strip(route.path), groupPageQuery)
    groupData = await getPage<KirbyGroupPageData>(groupQuery)
    page.programme = groupData.programme
  }

  const studentName = computed(() =>
    resolveStudentName({ ...groupData, name: page.name }),
  )

  const blocks = removeEmptyBlocks(page.content)

  return { page, blocks, studentName }
}
